import React from 'react';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {Anchor} from 'src/design/atoms/Anchor';
import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import {Title} from 'src/design/atoms/Title';
import type {UserGroupObjectPermissionResponse} from 'src/api/ProactApiClient';

import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {useGetObjectPermissionSchemaQuery} from 'src/redux/queries/userGroupPermissions';

import {Link} from 'react-router-dom';
import {
  GetObjectPermissionFieldLabel,
  MatchObjectPermissionSchemaToPermissions,
} from 'src/app/user-groups/userGroupHelpers';

export interface EffectiveObjectPermissionsProps {
  permissions?: UserGroupObjectPermissionResponse[];
}
export const EffectiveObjectPermissions: React.FC<
  EffectiveObjectPermissionsProps
> = ({permissions}) => {
  const {data: permissionSchema, isLoading: isSchemaLoading} =
    useGetObjectPermissionSchemaQuery();

  return isSchemaLoading ? (
    <TableBodyRender isLoading={isSchemaLoading} />
  ) : (
    <>
      {!permissions && (
        <Text>
          No permissions found for this user. Are they a member of a user group?
        </Text>
      )}
      {permissions &&
        permissionSchema &&
        permissionSchema?.modules.map(object => {
          const nodes: React.ReactNode[] = [];

          nodes.push(
            <Title size="sm" mt="lg">
              {object.name}
            </Title>
          );

          object.operations.forEach(operation => {
            const permission = MatchObjectPermissionSchemaToPermissions(
              object.module,
              operation.objectId!,
              permissions
            );
            const valueLabel =
              permission?.hasAccess === true
                ? 'Yes'
                : permission?.hasAccess === false
                ? 'No'
                : 'Not Set';

            if (
              permission?.hasAccess === true ||
              permission?.hasAccess === false
            ) {
              nodes.push(
                <Group mt="xs">
                  <Text size="sm">
                    {GetObjectPermissionFieldLabel(operation)}:{' '}
                    <Text
                      component="span"
                      size="sm"
                      c={permission?.hasAccess === true ? 'green' : 'red'}>
                      {valueLabel}
                    </Text>
                  </Text>
                  {permission?.userGroup?.id && (
                    <Anchor
                      component={Link}
                      to={PathUtility.UserGroupView(
                        permission.userGroup.id,
                        'object-permissions'
                      )}
                      target="_blank"
                      size="xs"
                      c="dimmed">
                      → {permission.userGroup.name}
                    </Anchor>
                  )}
                </Group>
              );
            }
          });

          if (nodes.length === 1) {
            nodes.push(
              <Text size="xs" c="dimmed" mt="md">
                No permissions found.
              </Text>
            );
          }
          return nodes;
        })}
    </>
  );
};
